
import LINK from 'constants/link';

import * as S from './index.styles';

import Button from '../Button';

// 이 컴포넌트는 RouterProvider 바깥(App.js의 ErrorBoundary fallback)에서도 렌더된다.
// useNavigate/useRouteError 같은 라우터 훅은 컨텍스트가 없으면 invariant를 던져
// fallback 자신이 터지므로, 라우터에 의존하지 않는 이동 수단만 사용한다.
// 에러 화면에서는 하드 내비게이션이 오히려 손상된 상태를 초기화해 준다.
function ErrorFallback({ error }) {
	console.error(error);

	const handleClickToMain = () => {
		window.location.assign(LINK.HOME);
	};

	const handleClickToBack = () => {
		window.history.back();
	};

	return (
		<S.Body>
			<S.Top>
				<S.ImgBox>
					<img src="/assets/icons/error.svg" />
				</S.ImgBox>

				<div>
					<S.Title>죄송합니다. 원하시는 페이지를 찾을 수 없습니다.</S.Title>

					<S.Content>
						존재하지 않는 주소가 잘못 입력하셨거나,
						<br />
						요청하신 페이지의 주소가 변경 혹은 삭제되어 찾을 수 없습니다.
						<br />
						입력하신 페이지의 주소가 정확한지 다시 한 번 확인해 주세요.
					</S.Content>
				</div>
			</S.Top>

			<S.ButtonBox>
				<Button
					variant="white"
					size="error"
					onClick={() => handleClickToBack()}
				>
					이전으로
				</Button>
				<Button
					variant="default"
					size="error"
					onClick={() => handleClickToMain()}
				>
					메인으로
				</Button>
			</S.ButtonBox>
		</S.Body>
	);
}

export default ErrorFallback;
